<template>
  <form class="form-inline my-2 my-lg-0" v-if="$store.getters.loggedUser">
    <div class="input-group ml-auto ml-lg-0 mr-0 mr-lg-2">
      <!--<div class="input-group-prepend">-->
      <!--<span class="input-group-text">🔍</span>-->
      <!--</div>-->
      <input
        class="form-control"
        type="search"
        :placeholder="$t('search.placeholder')"
        :aria-label="$t('search.button')"
        v-model="query"
      />
      <div class="input-group-append">
        <span class="input-group-text">
          <v-icon name="search" />
        </span>
      </div>
    </div>
  </form>
</template>

<script>
import "vue-awesome/icons/search";

export default {
  name: "SearchBar",
  computed: {
    query: {
      get() {
        return this.$store.getters.searchQuery;
      },
      set(query) {
        if (query.length) {
          this.$store.commit("search", query);
        } else {
          this.$store.commit("clearSearch");
        }
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
